import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useStoryIdentifier = () => {
  const {prefixedStoryId} = useParams<{
    prefixedStoryId?: string;
  }>();
  const storyId = getEntityIdFromRouteParam(prefixedStoryId);

  return storyId
    ? {
        $case: 'id' as const,
        id: storyId,
      }
    : null;
};
